import "./NewDealJourney.css";

import { useContext } from "react";
import { useNavigate } from "react-router-dom";

import { ArrowFullLeftDarkIcon } from "../../../assets";
import { DealJourneyNavigatorPages } from "../../../constants";
import { AssetManagerTemplate } from "../../../templates";
import { Button, Column, Row } from "../../../widget";
import { DealJourneyNavigator } from "./components";
import { ResumeDraftDealModal } from "./components/ResumeDraftDealModal";
import { DealAssociations } from "./DealAssociations";
import { DealDetails } from "./DealDetails/DealDetails";
import { DealStructure } from "./DealStructure";
import { DealWorkflow } from "./DealWorkflow";
import { Holding } from "./Holding";
import { NewDealJourneyContext } from "./NewDealJourneyContext";

const getDealJourneyPage = (currentPage: DealJourneyNavigatorPages): JSX.Element => {
  switch (currentPage) {
    case DealJourneyNavigatorPages.ASSOCIATIONS:
      return <DealAssociations />;
    case DealJourneyNavigatorPages.STRUCTURE:
      return <DealStructure />;
    case DealJourneyNavigatorPages.WORKFLOW:
      return <DealWorkflow />;
    case DealJourneyNavigatorPages.DETAILS:
    default:
      return <DealDetails />;
  }
};

const NewDealJourney = (): JSX.Element => {
  const navigate = useNavigate();
  const { currentPage, showHoldingPage, showDraftModal, handleUseDraft, handleStartFresh } =
    useContext(NewDealJourneyContext);

  return (
    <AssetManagerTemplate>
      {showHoldingPage ? (
        <Holding />
      ) : (
        <div className="NewDealJourney">
          <Row spacingV="m">
            <Column span={12}>
              <Button
                text="Back"
                variant="secondary"
                icon={<ArrowFullLeftDarkIcon />}
                iconPosition="left"
                onClick={() => navigate(-1)}
                hasNoPadding
                minWidth={false}
                className="NewDealJourneyBackButton"
              />
            </Column>
          </Row>
          <Row spacingV="l">
            <Column span={6}>
              <h1>New deal</h1>
            </Column>
            <Column span={6} justify="end">
              <DealJourneyNavigator />
            </Column>
          </Row>
          <Row>
            <Column span={12}>{getDealJourneyPage(currentPage)}</Column>
          </Row>
        </div>
      )}
      <ResumeDraftDealModal
        showDraftModal={showDraftModal}
        handleUseDraft={handleUseDraft}
        onClose={handleStartFresh}
      />
    </AssetManagerTemplate>
  );
};

export default NewDealJourney;
